module.exports = __webpack_public_path__ + "static/media/discard.2631613f.svg";